"use client";

import React from "react";
import { useState, useEffect } from "react";
import "react-phone-input-2/lib/bootstrap.css";
// import {
//   RecaptchaVerifier,
//   signInWithPhoneNumber,
//   PhoneAuthProvider,
//   signInWithCredential,
//   updatePhoneNumber,
// } from "firebase/auth";
// import { auth } from "../lib/firebase";
import OtpModal from "./OtpModal";
import { Button, Col, Modal, Row } from "react-bootstrap";
import CommonInput from "./CommonInput";
import CommonButton from "./CommonButton";
import { Formik } from "formik";
import * as Yup from "yup";
import { useRouter } from "next/navigation";
import {
  createCustomer,
  emailOtpVerification,
  emailResendOtpVerification,
  updateCustomer,
} from "@/services/pricing";
import isDisposableEmail from "is-disposable-email";
import { showToast } from "../../utils/libs/toast-utilis";
import ExitModal from "./exitModal";
import ConfirmModal from "./confirmModal";
import PhoneInput from "react-phone-input-2";
import { event } from "@/lib/analytics";
import { isValidPhoneNumber } from "../../utils/libs/utils";
export default function OTPVerification({
  modalShow,
  setModalShow,
  userRecord = { name: "", email: "", mobile: "", message: "" },
  isEdit = false,
  onUpdate,
}) {
  const [loading, setLoading] = useState(false);
  const [verificationId, setVerificationId] = useState("");
  const [userDetails, setUserDetails] = useState({ name: "", email: "", mobile: "", message: "" });
  const [error, setError] = useState("");
  const route = useRouter();
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [showExitModal, setShowExitModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const onHide = () => {
    setShowExitModal(true);
    event({
      action: "open exit dialog",
      params: {
        page: "price_page",
        ...userDetails,
      },
    });
  };
  const closeDialog = () => {
    setModalShow(false);
    setError("");
    setShowExitModal(false);
    event({
      action: "customer details dialog exit",
      params: {
        page: "price_page",
      },
    });
  };

  useEffect(() => {
    // Cleanup function for recaptcha
    return () => {
      if (window.recaptchaVerifier) {
        window.recaptchaVerifier.clear();
      }
    };
  }, []);
  // useEffect(() => {
  //   setUserDetails(userRecord);
  // }, [userRecord]);
  // const setupRecaptcha = () => {
  //   if (typeof window !== "undefined" && !window.recaptchaVerifier) {
  //     window.recaptchaVerifier = new RecaptchaVerifier(
  //       auth,
  //       "recaptcha-container",
  //       {
  //         size: "invisible",
  //         callback: () => {
  //         },
  //         "expired-callback": () => {
  //           showToast.error("Recaptcha expired. Please try again.");
  //           setError("Recaptcha expired. Please try again.");
  //         },
  //       }
  //     );
  //   }
  // };
  const sendOTP = async (userDetails) => {
    // if (!userDetails?.mobile.trim()) {
    //   showToast.error("Please enter a valid phone number.");
    //   setError("Please enter a valid phone number.");
    //   return;
    // }
    const formattedPhone = userDetails?.mobile.startsWith("+")
      ? userDetails?.mobile
      : `+${userDetails?.mobile.replace(/\D/g, "")}`;
    if (isDisposableEmail(userDetails?.email)) {
      showToast.error("Please use a valid personal or business email address.");
      setError("Please use a valid personal or business email address.");
      return;
    }
    if (!isValidPhoneNumber(formattedPhone)) {
      showToast.error("Please enter a valid phone number.");
      setError("Please enter a valid phone number");
      return;
    }
    setLoading(true);
    setError("");
    try {
      let res = null;
      // if (!window.recaptchaVerifier) {
      //   setupRecaptcha();
      // }
      // const appVerifier = window.recaptchaVerifier;
      // if (isEdit) {
      //   const provider = new PhoneAuthProvider(auth);
      //   const verificationId = await provider.verifyPhoneNumber(
      //     formattedPhone,
      //     appVerifier
      //   );
      //   setVerificationId(verificationId);
      // } else {
      //   const confirmationResult = await signInWithPhoneNumber(
      //     auth,
      //     formattedPhone,
      //     appVerifier
      //   );
      //   setVerificationId(confirmationResult.verificationId);
      // }
      if (isEdit) {
        res = await updateCustomer(
          {
            name: userDetails?.name,
            project_summary: userDetails?.message,
            email: userDetails?.email,
            mobile_number: formattedPhone,
          },
          userDetails?._id
        );
      } else {
        res = await createCustomer({
          name: userDetails?.name,
          project_summary: userDetails?.message,
          email: userDetails?.email,
          mobile_number: formattedPhone,
        });
      }

      setModalShow(false);
      setShowOtpModal(true);
      setError("");
      event({
        action: isEdit ? "update customer details" : "customer details",
        params: {
          page: isEdit ? "project_price_page" : "price_page",
          ...userDetails,
        },
      });
      showToast.success(
        "Verification code has been sent to your email address!!"
      );
      // if (window.recaptchaVerifier) {
      //   window.recaptchaVerifier.clear();
      //   window.recaptchaVerifier = null;
      // }
    } catch (err) {
      showToast.error(getErrorMessage(err));
      setError(getErrorMessage(err));
      // if (window.recaptchaVerifier) {
      //   window.recaptchaVerifier.clear();
      //   window.recaptchaVerifier = null;
      // }
    }

    setLoading(false);
  };
  const resetForm = () => {
    setError("");
    setVerificationId("");
    // if (window.recaptchaVerifier) {
    //   window.recaptchaVerifier.clear();
    //   window.recaptchaVerifier = null;
    // }
  };
  const verifyOTP = async (otp) => {
    if (!otp || otp.length !== 6) {
      showToast.error("Please enter a valid 6-digit OTP.");
      setError("Please enter a valid 6-digit OTP.");
      return;
    }
    setLoading(true);
    try {
      if (isEdit) {
        // const credential = PhoneAuthProvider.credential(verificationId, otp);
        // const user = auth.currentUser;
        // if (!user) {
        //   showToast.error("User not authenticated.");
        //   return;
        // }
        // await updatePhoneNumber(user, credential);
        const res = await emailOtpVerification({
          otp: otp,
          email: userDetails?.email,
        });

        localStorage.setItem("authDetails", JSON.stringify(res));
        onUpdate();
        setShowOtpModal(false);
        showToast.success("User Update verified successfully!");
      } else {
        // const credential = PhoneAuthProvider.credential(verificationId, otp);
        // const result = await signInWithCredential(auth, credential);
        const res = await emailOtpVerification({
          otp: otp,
          email: userDetails?.email,
        });
        showToast.success("User verified successfully!");
        localStorage.setItem("authDetails", JSON.stringify(res));
        route.push("/custom-pricing");
      }
      resetForm();
    } catch (err) {
      showToast.error(getErrorMessage(err));
      setError(getErrorMessage(err));
      setLoading(false);
    }

    // setLoading(false);
  };

  const getErrorMessage = (error) => {
    switch (error.code) {
      case "auth/invalid-phone-number":
        return "Invalid phone number format";
      case "auth/too-many-requests":
        return "Too many requests. Please try again later";
      case "auth/invalid-verification-code":
        return "Invalid OTP. Please check and try again";
      case "auth/code-expired":
        return "OTP has expired. Please request a new one";
      default:
        return error.message || "An error occurred. Please try again";
    }
  };

  const initialValues = {
    name: "",
    email: "",
    mobile: "",
    message: "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    mobile: Yup.string()
      .required("Mobile number is required")
      .test("is-valid", "Enter a valid phone number", (value) => {
        const digitsOnly = value?.replace(/\D/g, "");
        return digitsOnly && digitsOnly.length >= 10 && digitsOnly.length <= 15;
      }),
    message: Yup.string(),
  });

  const handleSubmit = (values) => {
    setUserDetails(values);
    sendOTP(values);
  };
  return (
    <div>
      <Modal
        show={modalShow}
        onHide={onHide}
        size="xl"
        backdrop="static"
        keyboard={false}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Row className="gy-4">
          <Col lg={6} md={12}>
            <div className="p-lg-3 pe-lg-0 h-100">
              <div className="modal-left"></div>
            </div>
          </Col>
          <Col lg={6} md={12}>
            <div className="pt-lg-3 pe-lg-3 pb-lg-3">
              <Modal.Header className="border-0">
                <div>
                  <Modal.Title id="contained-modal-title-vcenter">
                    <span>Trust us,</span> {"we won't spam you"}
                  </Modal.Title>
                  <p className="p-0 m-0" style={{ fontSize: "14px" }}>
                    To provide pricing that’s truly relevant to your business,
                    please share a few quick details.
                  </p>
                </div>
              </Modal.Header>
              <Formik
                initialValues={userDetails || initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  values,
                  errors,
                  touched,
                  setFieldValue,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Modal.Body className="pt-0">
                      <Row className="gy-3">
                        <Col xl={12}>
                          <CommonInput
                            name="name"
                            placeholder="Enter your name"
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="price-input"
                            error={touched.name && errors.name}
                          />
                        </Col>
                        <Col xl={6} md={12}>
                          <CommonInput
                            name="email"
                            placeholder="Enter your email"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="price-input"
                            error={touched.email && errors.email}
                          />
                        </Col>
                        <Col xl={6} md={12}>
                          <PhoneInput
                            country={"in"}
                            value={values.mobile}
                            onChange={(value) => setFieldValue("mobile", value)}
                            inputClass="w-100 price-input"
                            inputStyle={{ width: "100%" }}
                            containerStyle={{ width: "100%" }}
                            countryCodeEditable={true}
                            placeholder="Enter mobile number"
                            inputProps={{
                              onBlur: handleBlur,
                              name: "mobile",
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                handleSubmit();
                              }
                            }}
                          />
                          {touched.mobile && errors.mobile && (
                            <div className="invalid-feedback d-block">
                              {errors.mobile}
                            </div>
                          )}
                        </Col>
                        <Col xl={12}>
                          <CommonInput
                            name="message"
                            placeholder="Write your project summary (Optional)"
                            isTextArea
                            rows={5}
                            value={values.message}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="price-input"
                            error={touched.message && errors.message}
                          />
                        </Col>
                        {/* {error && (
                          <div className="invalid-feedback d-block text-center">
                            {error}
                          </div>
                        )} */}
                        <Col xl={12}>
                          <div
                            className="d-flex gap-3 justify-content-end position-relative"
                            style={{ zIndex: 0 }}
                          >
                            <CommonButton
                              label="Cancel"
                              variant="outline"
                              className="black-border"
                              onClick={onHide}
                              type="button"
                            />
                            <CommonButton
                              label={isEdit ? "Update" : "Submit"}
                              disabled={loading}
                              className="btn-primary"
                              type="submit"
                            />
                          </div>
                        </Col>
                      </Row>
                    </Modal.Body>
                  </form>
                )}
              </Formik>
            </div>
          </Col>
        </Row>
      </Modal>
      <OtpModal
        show={showOtpModal}
        onHide={() => {
          setShowOtpModal(false);
          setError("");
          setUserDetails(null);
        }}
        verifyOTP={verifyOTP}
        loading={loading}
        userDetails={userDetails}
        error={error}
      />
      <ExitModal
        show={showExitModal}
        onHide={() => setShowExitModal(false)}
        exitBtn={closeDialog}
      />
      <ConfirmModal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        primaryBtn={() => setShowConfirmModal(false)}
        secondBtn={() => setShowConfirmModal(false)}
      />
      {/* Recaptcha Container */}
      <div id="recaptcha-container"></div>
    </div>
  );
}
